import type { ReactNode } from 'react';

/** Readable form input styling (16px) */
export const contextFieldInputClass =
  'settings-field-input w-full rounded-[10px] border border-[#eef2f6] bg-white px-3 py-2.5 text-base font-medium text-[#1e293b] outline-none transition-[border-color,box-shadow] focus:border-[#cbd5e1] focus:ring-2 focus:ring-[#3B82F6]/15 disabled:cursor-not-allowed disabled:opacity-60';

export const contextSectionTitleClass =
  'case-info-context-section-title text-[16px] font-bold uppercase tracking-[0.12em]';

export const contextFieldLabelClass = 'case-info-context-row-label text-sm font-medium';

export const contextDescriptionClass =
  'case-info-context-row-value text-sm font-medium leading-relaxed text-[#64748b]';

export const contextRowValueClass = 'case-info-context-row-value text-sm font-normal leading-relaxed';

export function ContextSectionTitle({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p className={`${contextSectionTitleClass} mb-3 ${className}`.trim()}>
      {children}
    </p>
  );
}

export function ContextFieldLabel({
  children,
  htmlFor,
  className = '',
}: {
  children: ReactNode;
  htmlFor?: string;
  className?: string;
}) {
  return (
    <label
      htmlFor={htmlFor}
      className={`${contextFieldLabelClass} mb-1.5 block ${className}`.trim()}
    >
      {children}
    </label>
  );
}

export function ContextDescription({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p className={`${contextDescriptionClass} mb-3 ${className}`.trim()}>
      {children}
    </p>
  );
}
